import React from 'react';
import { Drawer, Button, IconButton, Typography, Box } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import darkLogo from '../../../../../assets/DarkLogo.svg';
import { logoStyles } from '../../../../../styles/commonStyles';
import { navRoutes } from '../../../../../constants/navRoutes';
import { mobileSidebarStyles } from './MobileSidebar.styles';

const MobileSidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const styles = mobileSidebarStyles(isOpen);

  const isActiveRoute = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: styles.drawerPaper,
      }}
    >
      <Box sx={styles.sidebar}>
        {/* Header with Logo and Close Icon */}
        <Box sx={styles.header}>
          <Box>
            <img
              src={darkLogo}
              alt="Royal Vista Logo"
              loading="lazy"
              style={logoStyles}
            />
          </Box>
          <IconButton
            onClick={onClose}
            sx={styles.closeButton}
          >
            <CloseIcon sx={styles.closeIcon} />
          </IconButton>
        </Box>

        {/* Navigation Links */}
        <Box sx={styles.navContainer}>
          {navRoutes.map((route) => (
            <Typography
              key={route.path}
              component={RouterLink}
              to={route.path}
              onClick={onClose}
              sx={{
                ...styles.navLink,
                ...(isActiveRoute(route.path) && styles.navLinkActive),
              }}
            >
              {route.label}
            </Typography>
          ))}
        </Box>

        {/* Bottom Buttons */}
        <Box sx={styles.buttonContainer}>
          <Button
            variant="outlined"
            fullWidth
            sx={styles.signInButton}
            onClick={() => window.open('https://royalvista.guestyowners.com/login', '_blank')}
          >
            Owner Login
          </Button>
          <Button
            variant="contained"
            disableElevation
            fullWidth
            sx={styles.bookStayButton}
            onClick={() => window.open('https://royal-vista.guestybookings.com/en/properties', '_blank')}
          >
            Book your stay
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default MobileSidebar;

